import React from 'react'
import { SignFormStep1LkClient } from '@shared/components/forms/sign/steps/step1-lk-client/form'

export const View = () => <SignFormStep1LkClient />
